"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwiperRail = exports.SwiperCell = exports.Swiper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useCursor2 = require("use-cursor");

var _visuallyDisableScrollbar = require("../../helpers/visuallyDisableScrollbar");

var _Box = require("../Box");

var _Carousel = require("../Carousel");

var _activeIndex = require("./activeIndex");

var _percentage = require("./percentage");

var _excluded = ["initialIndex", "children", "snap", "Rail", "Cell", "onChange", "onPageCountChange"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Swiper__Container",
  componentId: "sc-1bxg2ho-0"
})(["display:flex;height:100%;padding:0;list-style:none;overflow-y:hidden;overflow-x:scroll;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;", ""], _visuallyDisableScrollbar.visuallyDisableScrollbar);
/** SwiperRailProps */

/** A `SwiperRail` slides back and forth within the viewport */

var SwiperRail = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Swiper__SwiperRail",
  componentId: "sc-1bxg2ho-1"
})(["width:100%;height:100%;margin:0;padding:0;list-style:none;white-space:nowrap;"]);
exports.SwiperRail = SwiperRail;
SwiperRail.defaultProps = {
  display: "flex"
};
/** SwiperCellProps */

/** A `SwiperCell` wraps a single child in the carousel */

var SwiperCell = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Swiper__SwiperCell",
  componentId: "sc-1bxg2ho-2"
})(["white-space:normal;"]);
exports.SwiperCell = SwiperCell;
/**
 * A `Swiper` is like a `Carousel` but for touch devices. It accepts children
 * or a series of children that are JSX elements. It presents them in a
 * horizontal rail and when the width exceeds the width of the viewport, allows
 * for horitonzal swiping (or scrolling) with the option to snap to elements.
 */

var Swiper = function Swiper(_ref) {
  var _ref$initialIndex = _ref.initialIndex,
      initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
      children = _ref.children,
      _ref$snap = _ref.snap,
      snap = _ref$snap === void 0 ? "none" : _ref$snap,
      _ref$Rail = _ref.Rail,
      Rail = _ref$Rail === void 0 ? SwiperRail : _ref$Rail,
      _ref$Cell = _ref.Cell,
      Cell = _ref$Cell === void 0 ? SwiperCell : _ref$Cell,
      onChange = _ref.onChange,
      onPageCountChange = _ref.onPageCountChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var containerRef = (0, _react.useRef)(null);
  var cells = (0, _react.useMemo)(function () {
    return _react.Children.toArray(children).filter(_react.isValidElement).map(function (child) {
      return {
        child: child,
        ref: /*#__PURE__*/(0, _react.createRef)()
      };
    });
  }, [children]);

  var _useCursor = (0, _useCursor2.useCursor)({
    initialCursor: initialIndex,
    max: cells.length
  }),
      index = _useCursor.index,
      cursor = _useCursor.cursor,
      setCursor = _useCursor.setCursor;

  (0, _react.useEffect)(function () {
    /**
     * If on initial mount there is an `initialIndex` other than `0`,
     * scroll it into view. The dependency array is left empty as we explicitly
     * only want this to run on mount, and ignore any updates to `initialIndex`,
     * which are handled separately below.
     */
    if (initialIndex === 0) return;
    var cell = cells[initialIndex];
    if (!cell) return;
    cell.ref.current.scrollIntoView({
      inline: "start",
      block: "nearest"
    });
  }, []);
  (0, _react.useEffect)(function () {
    /**
     * Since `cursor` tracks progress, if `cursor` and `initialIndex` are out
     * of sync then that means the index has been changed programmatically
     * and we should scroll the cell corresponding with that index into view.
     */
    if (initialIndex !== cursor) {
      var cell = cells[initialIndex];
      if (!cell) return;
      cell.ref.current.scrollIntoView({
        inline: "start",
        block: "nearest"
      });
    }
  }, [initialIndex]);
  (0, _react.useEffect)(function () {
    // Not mounted
    if (!containerRef.current) return; // No need to track progress

    if (!onChange) return;
    var rail = containerRef.current;

    var handleScroll = function handleScroll() {
      var progress = (0, _percentage.percentage)({
        viewport: rail.clientWidth,
        total: rail.scrollWidth,
        left: rail.scrollLeft
      });
      var page = (0, _activeIndex.activeIndex)({
        progress: progress,
        length: cells.length
      });
      setCursor(page);
    };

    rail.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return function () {
      rail.removeEventListener("scroll", handleScroll);
    };
  }, [cells]);
  (0, _react.useEffect)(function () {
    onChange && onChange(index);
  }, [onChange, index]);
  (0, _react.useEffect)(function () {
    onPageCountChange && onPageCountChange(cells.length);
  }, [onPageCountChange, cells.length]);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: containerRef,
    mx: 0,
    my: 0
  }, rest), /*#__PURE__*/_react.default.createElement(Rail, {
    as: "ul"
  }, cells.map(function (_ref2, i) {
    var child = _ref2.child,
        ref = _ref2.ref;
    var isLast = i === cells.length - 1;
    return /*#__PURE__*/_react.default.createElement(Cell, {
      as: "li",
      key: i,
      ref: ref,
      pr: !isLast ? _Carousel.CELL_GAP_PADDING_AMOUNT : undefined,
      style: {
        scrollSnapAlign: snap
      }
    }, child);
  })));
};

exports.Swiper = Swiper;
Swiper.displayName = "Swiper";